module.exports = __webpack_public_path__ + "static/media/lv.2ee80329.svg";